(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
   typeof define === 'function' && define.amd ? define(factory) :
   (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.CookieBar = factory());
}(this, (function () { 'use strict';

/*!
 * Generating a cookie consent notice
 * @version 1.0.2
 */

	const defaults = {
	   selector: "#cookieBar",
	   message: undefined,
	   button: "ACCEPT",
	   theme: "#fff",
	   expire: "24",
	   storage: "cookie",
	};

	function extend(defaults, options ) {
	   var extended = {};
	   var prop;
	   for (prop in defaults) {
		  if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
			  extended[prop] = defaults[prop];
		  }
	   }
	   for (prop in options) {
		  if (Object.prototype.hasOwnProperty.call(options, prop)) {
			  extended[prop] = options[prop];
		  }
	   }
	   return extended;
	}
	
	function setLStorage(name, value, expireHrs) {
		var cookieDate = Date.now() + expireHrs * 60 * 60 * 1000;
        localStorage.setItem( name, cookieDate );
	}
	
	function getLStorage(name) {
		var cookieDate = localStorage.getItem(name) || 0;
	    if( cookieDate && cookieDate > Date.now() ) return 'accepted';
	}	
	
	function setCookie(name, value, expireHrs) {
		var d = new Date();
		d.setTime(d.getTime() + expireHrs * 60 * 60 * 1000);
		document.cookie = name + "=" + value + ";" + "samesite=lax;" + "expires=" + d.toUTCString() + ";path=/";
	}
	function getCookie(name) {
		function escape(s) {
			return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, "\\$1");
		}
		var match = document.cookie.match(
			RegExp("(?:^|;\\s*)" + escape(name) + "=([^;]*)")
		);
		return match ? match[1] : null;
	}

	function cookie_bar(settings){
		var ccExpire = settings.expire;

		var ccbar = document.querySelector(settings.selector);
		if (ccbar && settings.message){
			
			var checkStorage = (settings.storage == 'cookie') ? getCookie("cc-bar-cookies") : getLStorage("cc-bar-cookies");
			
			
			if (checkStorage != "accepted") {
				var ccbarMsgBox = document.createElement('div');
				ccbarMsgBox.classList.add("cc-bar-col");
				ccbarMsgBox.innerHTML = settings.message;
				ccbar.appendChild(ccbarMsgBox);
				var ccbarBtnBox = document.createElement('div');
				ccbarBtnBox.classList.add("cc-bar-col");
				ccbarBtnBox.innerHTML = '<a class="cc-bar-btn" href="#">' + settings.button + '</a>';
				ccbar.appendChild(ccbarBtnBox);	
				
				ccbar.style.display = "flex";
				ccbar.style.animation =
					"cc-bar-fadeIn 0.5s ease both";
					
				// Update cookies when clicked button
				ccbarBtnBox.querySelector(".cc-bar-btn").addEventListener('click', function (e) {
					e.preventDefault();
					if (settings.storage == 'cookie'){
						setCookie("cc-bar-cookies", "accepted", ccExpire);
					}else{
						setLStorage("cc-bar-cookies", "accepted", ccExpire);
					}
					ccbar.style.animation =
						"cc-bar-fadeOut 0.5s ease both";
					setTimeout(function () {
						ccbar.style.display = "none";
					}, 500);
				});
					
				document.head.insertAdjacentHTML("beforeend", "<style>"
				+ settings.selector + " {\
					display: none;\
					position: fixed;\
					left: 0;\
					bottom: 0;\
					z-index: 500;\
					align-items: center;\
					text-align: center;\
					flex-direction: row;\
					justify-content: center;\
					color: rgb(100 100 100);\
					background-color: rgb(255 255 255 / 95%);\
					font-family: inherit;\
					padding: 10px;\
					margin: 0px;\
					box-shadow: 0 -1px 3px 0 #E9E9E9;\
					box-sizing: border-box;\
					border: none " + settings.theme + ";\
					border-radius: 2px;\
					width: 100%;\
				}"
				+ settings.selector + " .cc-bar-col {\
					width: auto;\
				}"
				+ settings.selector + " .cc-bar-col .cc-bar-btn {\
					display: block;\
					font-size: 14px;\
					padding: 7px 15px;\
					margin: 0 10px 0 10px;\
					color: rgb(100 100 100);\
					/*background-color: " + settings.theme + ";*/\
					background-color: #FFFFFF;\
					text-decoration: none;\
					white-space: nowrap;\
					text-align: center;\
					box-sizing: border-box;\
					border: 1px solid #E9E9E9;\
					border-radius: 10px;\
				}"
				+ settings.selector + " .cc-bar-col:hover .cc-bar-btn:hover {\
					transition: all 0.2s;\
					box-shadow: 0 7px 14px rgb(65 132 144 / 5%), 0 3px 6px rgb(0 0 0 / 15%);\
				}\
				@keyframes cc-bar-fadeIn {\
					from { opacity:0; transform:translateY(50px); }\
					to { opacity:1; transform:translateY(0); }\
				}\
				@keyframes cc-bar-fadeOut {\
					from { opacity:1; transform:translateY(0); }\
					to { opacity:0; transform:translateY(50px); }\
				}\
				@media only screen and (max-width: 580px) {"
					+ settings.selector + " {\
						font-size: 16px;\
						flex-direction: column;\
						margin: 0;\
						width: 100%;\
						border-radius: 0;\
					}"
					+ settings.selector + " .cc-bar-col {\
						width: 100%;\
					}"
					+ settings.selector + " .cc-bar-col .cc-bar-btn {\
						font-size: 16px;\
						margin: 10px 0 0 0;\
					}\
				}\
				</style>");
					
			}
		}
	}

	// Конструктор
	var CookieBar = function(options) {
		var settings = extend( defaults, options || {} );
		this.isConfirm = cookie_bar(settings);
	};
	return CookieBar;
})));
